module.exports = __webpack_public_path__ + "img/1.d22812f5.png";